"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacySmall = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function PharmacySmall({ size = 20, color = '#000' }) {
    return (react_1.default.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 31 31" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            react_1.default.createElement(react_native_svg_1.G, { fill: color, fillRule: "nonzero" },
                react_1.default.createElement(react_native_svg_1.Path, { d: "M15.98.238l.09.086 14.667 16a1 1 0 01-1.384 1.439l-.09-.087L27 15.207V30a1 1 0 01-.883.993L26 31H5a1 1 0 01-.993-.883L4 30V15.149l-2.255 2.518a1 1 0 01-1.314.156l-.098-.078a1 1 0 01-.156-1.314l.078-.098 14.334-16A1 1 0 0115.98.238zm-.638 2.251L5.995 12.922 6 13v16h19V13.025L15.342 2.489z" }),
                react_1.default.createElement(react_native_svg_1.Path, { d: "M15.5 11.25a1 1 0 01.993.883l.007.117V17H21a1 1 0 01.117 1.993L21 19h-4.5v4.25a1 1 0 01-1.993.117l-.007-.117V19H10a1 1 0 01-.117-1.993L10 17h4.5v-4.75a1 1 0 011-1z" })))));
}
exports.PharmacySmall = PharmacySmall;
